/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');
window.modal = require('./modal');
const VueToast = require('vue-toast-notification');
import "vue-toast-notification/dist/theme-sugar.css";

window.Vue.use(VueToast,  {
    position: 'top-left'
});

window.Vue.mixin({
    data() {
        return {
            get resource_group(){
                return window.resource_group
            }
        }
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

require('./vue_components');

const app = new Vue({
    el: '#app',
    methods: {
        triggerOpenModel() {
            this.$refs.companyPeoplePage.openModel();
        }
    }
});

const headerVue = new Vue({
    el: '#header-content',
    methods: {
        buttonClicked() {
            EventBus.$emit('triggerOpenModelEvent');
        }
    }
});

import { EventBus } from './event-bus';
EventBus.$on('triggerOpenModelEvent', () => {
    app.triggerOpenModel();
});
